var IconMask = {};

IconMask.gen = function (elemento) {
	var parent = elemento.parentNode;

	var mask 	= elemento.getAttribute('src');
	var width 	= elemento.getAttribute('width') || 0;
	var height = elemento.getAttribute('height') || 0;

	var template = '<div class="iconmask" style="mask-image: url('+mask+');'+
		'-webkit-mask-image: url('+mask+'); width: '+width+'px;'+
		'height: '+height+'px;'+
		'"></div>';

	elemento.insertAdjacentHTML('beforebegin', template);

	parent.removeChild(elemento);
}

IconMask.start = (function(){
	var iconsmask =  document.querySelectorAll('iconmask');

	for(var i=0; i< iconsmask.length; i++){

		IconMask.gen( iconsmask[i] );

	}
})();